/* DAY OFF REQUEST */
Vue.component('dayoffrequest',{
    template:'#dayoffrequest-template',
    data:function(){
        return{
            project_number:0,
            date_start:'',
            date_end:'',
            type:'day_off',
            half_day:false,
            workers:[],
            activeWorkerId:'',
            workhours_off_this_year:0,
            recent_free_time_records:[],
            day_off_statistics:[],
            company_day_off_records:[],
        };
    },
    created:function(){

        setTimeout(function(){
            $(function () {
                $('#datetimepicker5').datetimepicker({
                    format: 'YYYY-MM-DD',
                    locale: 'hu'
                });
                $('#datetimepicker6').datetimepicker({
                    format: 'YYYY-MM-DD',
                    locale: 'hu'
                });
                activeInstance.getCalendarData();
            });
        },300);

        activeInstance = this;

        setTimeout(function(){
            var $table = $('.fixed_header_table');
            $table.floatThead({
                top:70
            });
        },200);

        var id = $('#content_wrapper').attr('data-id');
        activeInstance.getAllWorkers();
        activeInstance.getUserRecordsForTheYear();
        activeInstance.getDayOffStatistics();
    },
    events: {
        //ON CLIENT SELECTION
        'autocomplete-result:selected': function(data){
            console.log(data);
            activeInstance.project_number = data.project_number;
        }
    },
    methods:{
        initializeCalendar:function() {
            if ($('#calendar_monthly').children().length > 0) {
                console.log("destroy");
                $('#calendar_monthly').fullCalendar('destroy');
            }

            //MONTH VIEW
            $('#calendar_monthly').fullCalendar({
                weekends: true,
                allDayDefault:true,
                now: moment(),
                nowIndicator: true,
                // put your options and callbacks here
                events: activeInstance.company_day_off_records,
                eventClick: function(calEvent, jsEvent, view) {
                    // change the border color just for fun
                    $(this).css('border-color', 'red');

                },
                eventAfterRender: function(event, element, view) {
                    
                    $(element).attr("title", event.user_name);

                    if (event.duration / 3600 == 4) {

                        // set width of element
                        $(element).css({
                            width: $(element).width()/2 + "px",
                            marginLeft: $(element).width()/4 + "px"
                        });
                    }
                }
            });
        },
        getCalendarData:function(){
            showLoadingOverlay();
            axios.get(baseURL+'/api/day_off_requests').then(function(response){
                $('body').LoadingOverlay("hide");
                //console.log(response);
                response.data.forEach(function(record){
                    if(record.status == 'confirmed'){
                        record.color = '#2FBD7E';
                    }

                    if(record.status == 'unconfirmed'){
                        record.color = '#f8b356';
                    }

                    if(record.status == 'rejected'){
                        record.color = '#BD2F35';
                    }

                });
                activeInstance.company_day_off_records = response.data;
                activeInstance.initializeCalendar();
            });
        },
        undo:function(record){
            //console.log("undo");
            bootbox.confirm('Biztosan visszavonod a '+ record.date +' napra kért szabadságot?', function(value){
                if(value==true){

                    showLoadingOverlay();
                    Vue.http.post(baseURL+'/admin/day_off/undo', {'id':record.id}).then(function(response){
                        $('body').LoadingOverlay("hide");
                        activeInstance.getUserRecordsForTheYear();
                        activeInstance.getDayOffStatistics();
                        successNotification('OK');

                    }).bind(this);

                }
            });
        },
        getAllWorkers:function(){
            showLoadingOverlay();
            Vue.http.get(baseURL+'/api/worker/all').then(function(response){
                $('body').LoadingOverlay("hide");
                activeInstance.workers = response.data;

            }).bind(this);
        },
        getDayOffStatistics:function(){
            showLoadingOverlay();
            Vue.http.get(baseURL+'/api/user/day_off_statistics').then(function(response){

                $('body').LoadingOverlay("hide");
                activeInstance.day_off_statistics=response.data;

                if(activeInstance.day_off_statistics.free<0.5){
                    $('.send-button').addClass('faded').addClass('disabled');
                }
                else if(activeInstance.day_off_statistics.free>0.5)
                {
                    $('.send-button').removeClass('faded').removeClass('disabled');
                }
            });
        },
        getUserRecordsForTheYear:function(){

            showLoadingOverlay();
            Vue.http.get(baseURL+'/api/user/free_time_records').then(function(response){
                $('body').LoadingOverlay("hide");
                total_workhours = 0;
                $.each(response.data,function(index,timerecord){
                    console.log(timerecord.duration);
                    total_workhours = parseInt(total_workhours) + parseInt(timerecord.duration);
                });
                activeInstance.recent_free_time_records = response.data;
                activeInstance.workhours_off_this_year = total_workhours;

                /*
                setTimeout(function() {
                    var running_footable = FooTable.get(".responsive-table");
                    if (running_footable) {
                        running_footable.destroy();
                    }

                    $('.responsive-table').footable();
                },50);
                */

            }).bind(this);
        },
        send:function(){
            //$project_number,$user_id,$date_start,$date_end

            $('#datetimepicker5').removeClass('error');
            $('#datetimepicker6').removeClass('error');

            var validation = false;
            if(activeInstance.date_start.length > 2 && activeInstance.date_end.length > 2 ){
                validation = true;
            } else {

                if($('#datetimepicker5').find('input').val().length!=10){
                    $('#datetimepicker5').addClass('error');
                    errorNotification('Az intervallum vége nem megfelelő.');
                }
                if($('#datetimepicker6').find('input').val().length!=10){
                    $('#datetimepicker6').addClass('error');
                    errorNotification('Az intervallum kezdete nem megfelelő.');
                }


            }

            if(validation == false ){

                return false;
            }

            bootbox.confirm('Minden adat helyes?', function(value){
                if(value==true){

                    showLoadingOverlay();
                    Vue.http.post(baseURL+'/admin/request_day_off',{
                        'date_start':activeInstance.date_start,
                        'date_end':activeInstance.date_end,
                        'type':activeInstance.type,'half_day':activeInstance.half_day,
                        'confirmer_id':activeInstance.activeWorkerId
                    }).then(function(response){

                        $('body').LoadingOverlay("hide");
                        if (typeof response.data.result != 'undefined') {

                            if(response.data.result=='error'){
                                errorNotification(response.data.reason);
                            }

                            else if(response.data.result=='success'){
                                successNotification('A kérelem rögzítve.');
                                activeInstance.getDayOffStatistics();
                                activeInstance.date_start = '';
                                activeInstance.date_end = '';
                                activeInstance.half_day = 0;
                                activeInstance.type = 'day_off';

                                activeInstance.getUserRecordsForTheYear();
                                activeInstance.getDayOffStatistics();

                                activeInstance.getCalendarData();
                            }
                        }
                        else {
                            errorNotification('Hiba a feldolgozás során.');
                            activeInstance.getDayOffStatistics();
                        }

                    }).bind(this);

                }
            });
        },
        humanize:function(text){
            switch (text) {
                case 'day_off':
                    return 'Szabadság';
                    break;
                case 'sick_leave':
                    return 'Betegszabadság';
                    break;
                case 'unconfirmed':
                    return 'Elbírálás alatt';
                    break;
                case 'confirmed':
                    return 'Jóváhagyott';
                    break;
                case 'rejected':
                    return 'Elutasított';
                    break;
                default:
                    break;
            }
        }

    }
});